export default "/dist/files/icone_langue.1f2d833ae2f8196dbb746ac72427124c.svg";